const config = {
  API_BASE: process.env.REACT_APP_ADM_PORTAL_API_BASE || "https://admin.admediary.com",
};

export default config;
